import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { IdentificationCard, MoonStars, CaretRight } from "@phosphor-icons/react";

const KIND = {
  segundo_propietario: { label: "Segundo Propietario", Icon: IdentificationCard, cls: "text-sky-600 bg-sky-500/10" },
  fuera_de_horario: { label: "Fuera de horario", Icon: MoonStars, cls: "text-amber-700 bg-amber-500/10" },
};

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("es-DO", { dateStyle: "medium", timeStyle: "short" }) : "");

export default function PendingCasesDialog() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [cases, setCases] = useState([]);
  const [open, setOpen] = useState(false);

  // Check on login and every minute: queued cases get auto-assigned shortly after the rep connects.
  useEffect(() => {
    if (!user?.id) return;
    const key = `sdm_pending_seen_${user.id}`;
    const check = () => api.get("/me/pending-cases").then(({ data }) => {
      const seen = JSON.parse(sessionStorage.getItem(key) || "[]");
      if (data?.some((c) => !seen.includes(c.id))) {
        sessionStorage.setItem(key, JSON.stringify(data.map((c) => c.id)));
        setCases(data);
        setOpen(true);
      }
    }).catch(() => {});
    check();
    const iv = setInterval(check, 60000);
    return () => clearInterval(iv);
  }, [user?.id]);

  const go = (path) => { setOpen(false); navigate(path); };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="pending-cases-dialog">
        <DialogHeader>
          <DialogTitle>Tienes {cases.length} {cases.length === 1 ? "caso pendiente" : "casos pendientes"}</DialogTitle>
          <DialogDescription>Llegaron mientras no había representantes conectados.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {cases.map((c) => {
            const k = KIND[c.kind] || KIND.fuera_de_horario;
            return (
              <button key={c.id} onClick={() => go(`/inbox?conv=${c.id}`)} data-testid={`pending-case-${c.id}`}
                className="w-full flex items-center gap-3 rounded-lg border border-border p-3 text-left hover:bg-accent transition-colors">
                <span className={`rounded-md p-2 ${k.cls}`}><k.Icon size={18} weight="duotone" /></span>
                <span className="flex-1 min-w-0">
                  <span className="block font-medium truncate">{c.customer_name}</span>
                  <span className="block text-xs text-muted-foreground">{k.label} · {fmt(c.since)}</span>
                </span>
                <CaretRight size={16} className="text-muted-foreground" />
              </button>
            );
          })}
        </div>
        <Button onClick={() => go("/inbox?filter=pending")} data-testid="pending-cases-view-all-btn">Ver todos en la Bandeja</Button>
      </DialogContent>
    </Dialog>
  );
}
